"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useTransparency_1 = __importDefault(require("../../hooks/useTransparency"));
const styles_1 = require("./styles");
const RightLink = ({ forcedExternal, icon, isVisible, label, url }) => {
    const { isTransparent } = (0, useTransparency_1.default)();
    if (!isVisible)
        return null;
    return url ? ((0, jsx_runtime_1.jsxs)(styles_1.StyledLink, { variant: "tertiary", isTransparent: isTransparent, href: url, forcedExternal: forcedExternal, children: [icon, label && (0, jsx_runtime_1.jsx)(styles_1.StyledLabel, { children: label })] })) : ((0, jsx_runtime_1.jsxs)(styles_1.StyledIcon, { isTransparent: isTransparent, children: [icon, label && (0, jsx_runtime_1.jsx)(styles_1.StyledLabel, { children: label })] }));
};
exports.default = RightLink;
